import { useTranslate } from "src/i18n";

export const useLimiterCardTranslate = () => {
  const { t } = useTranslate();

  return {
    requestsCount: t("limiterCard.requestsCount", "Кол-во запросов"),
    unlimited: t("limiterCard.unlimited", "Безлимит"),
    expiresAt: t("limiterCard.expiresAt", "Истекает"),
    expiresIn: t("limiterCard.expiresIn", "Истекает через"),
    days: {
      one: t("limiterCard.days.one", "день"),
      few: t("limiterCard.days.few", "дня"),
      many: t("limiterCard.days.many", "дней"),
      other: t("limiterCard.days.other", "дней"),
    },
    hours: {
      one: t("limiterCard.hours.one", "час"),
      few: t("limiterCard.hours.few", "часа"),
      many: t("limiterCard.hours.many", "часов"),
      other: t("limiterCard.hours.other", "часов"),
    },
    expired: t("limiterCard.expired", "Истекло"),
    expiresToday: t("limiterCard.expiresToday", "Истекает сегодня"),
    test: t("limiterCard.test", "TEST"),
    limitations: t("limiterCard.limitations", "Ограничения"),
  };
};
